export class OperationFile {
    Name: string;
    Extension: string;
    Data: string;

    constructor(name: string, extension: string, data: string) {
        this.setName(name);
        this.setExtension(extension);
        this.setData(data);
    }

    getName() { return this.Name }
    getExtension() { return this.Extension }
    getData() { return this.Data }

    setName(name: string): void { this.Name = name }
    setExtension(extension: string): void { this.Extension = extension }
    setData(data: string): void { this.Data = data }

}